import React from 'react'

export default function EndBanner() {
  return (
    <article className="card content-body">
    <div className="row g-5">
       <div className="col-md-3">
          <div className="icontext">
             <div className="icon"> <span className="icon-sm"> <i className="fa fa-coins fa-lg text-primary"></i> </span> </div>
             <div className="text">
                <h6 className="title">Al mejor precio</h6>
                <p>Todos los días </p>
             </div>
          </div>
         
       </div>
       
       <div className="col-md-3">
          <div className="icontext">
             <div className="icon"> <span className="icon-sm"> <i className="fa fa-car fa-lg text-primary"></i> </span> </div>
             <div className="text">
                <h6 className="title">Envios Gratis</h6>
                <p>Por compras mayor a S/.99.00 </p>
             </div>
          </div>
         
       </div>
       
       <div className="col-md-3">
          <div className="icontext">
             <div className="icon"> <span className="icon-sm"> <i className="fa fa-comment-dots fa-lg text-primary"></i> </span> </div>
             <div className="text">
                <h6 className="title">24/7 Soporte</h6>
                <p>Soporte en vivo las 24H </p>
             </div>
          </div>
         
       </div>
       
       <div className="col-md-3">
          <div className="icontext">
             <div className="icon"> <span className="icon-sm"> <i className="fa fa-lock fa-lg text-primary"></i> </span> </div>
             <div className="text">
                <h6 className="title">Compra garantizada.</h6>
                <p>Garantizamos tu compra al 100% </p>
             </div>
          </div>
         
       </div>
      
    </div>
 </article>
  )
}
